import { useContext } from "react";
import {
  SnackbarContext,
  defaultDuration,
} from "./Snackbar";

// Custom hook to trigger the snackbar on function components
export const useSnackbar = () => {
  const { openSnackbar, closeSnackbar } = useContext(SnackbarContext);

  function open(text, className = "", duration = defaultDuration) {
    openSnackbar(text, className, duration);
  }

  // Returns methods in hooks array way
  return [open, closeSnackbar];
};
